import { takeResponseErrors } from "./takeResponseErrors";

export function extractApiErrorMessage(error) {
  const data = error?.response?.data ?? error?.data ?? error;
  if (!data) return null;

  if (typeof data === "string") return data;

  if (typeof data.message === "string" && data.message.trim()) return data.message;
  if (typeof data.error === "string" && data.error.trim()) return data.error;

  if (Array.isArray(data.errors)) {
    const firstString = data.errors.find((item) => typeof item === "string" && item.trim());
    if (firstString) return firstString;
  }

  if (data.errors && typeof data.errors === "object") {
    const messageFromErrors = takeResponseErrors(data.errors);
    if (messageFromErrors) return messageFromErrors;

    const values = Object.values(data.errors)
      .flat()
      .filter((item) => typeof item === "string" && item.trim());
    if (values.length > 0) return values[0];
  }

  if (typeof data.detail === "string" && data.detail.trim()) return data.detail;
  if (typeof data.title === "string" && data.title.trim()) return data.title;

  return null;
}
